import { Button, Chip, CopyElement } from "@ui";
import { CheckboxCell } from "./components/CheckboxCell/CheckboxCell";
import style from "./TableRow.module.scss";
import cn from "classnames";
import { Link } from "react-router-dom";
import { IUser } from "@interfaces/admin/user";

export function TableRow({
    data
}: {
    data: IUser
}) {
    return (
        <div className={style.row}>
            <div className={style.cell}>
                <CheckboxCell data={data}/>
            </div>
            
            <div className={style.cell}>
                <CopyElement 
                    element={<p className={style.userId}>id: {data.id}</p>}
                    copyText={String(data.id)}
                />
            </div>
            <div className={style.cell}>
                <Chip 
                    text={data.name}
                    color="blue"
                    size="big"
                />
            </div>
            <div className={cn(style.cell, "justify-self-end")}>
                <Link to={"./" + data.id + "?tab=proxy"}>
                    <Button
                        color="orange"
                        form="rectangle"
                        text="Детальніше"
                        customStyle={{
                            button: "!px-[35px] !py-[8px]"
                        }}
                    />
                </Link>
            </div>
        </div>
    )
}